import React, { useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { Form, Input } from "antd";

import { warn } from "../../../../modules/messages";

import "./index.css";

const { TextArea } = Input;

const TextAreaItem = ({
  getFieldDecorator,
  allowClear = true,
  formItemLayout,
  initialValue,
  wrapperCol,
  fieldName,
  maxLength,
  disabled,
  autoSize,
  labelCol,
  optional,
  message,
  label,
}) => {
  const intl = useIntl();

  useEffect(() => {
    const areas = document.querySelectorAll("textarea");
    areas.length > 1 &&
      areas[areas.length - 1].classList.length === 0 &&
      areas[areas.length - 1].classList.add("text-area-hidden");
  }, []);

  const handleChange = useCallback(
    ({ target: { value } }) => {
      maxLength &&
        value &&
        value.length >= maxLength &&
        warn(
          intl.formatMessage(
            {
              id: "messages.maxLength",
              defaultMessage: "Maximální povolená délka je {count} znaků.",
            },
            { count: maxLength }
          )
        );
    },
    [intl, maxLength]
  );

  return (
    <Form.Item
      colon={false}
      label={label}
      labelCol={
        labelCol
          ? { span: labelCol }
          : formItemLayout && formItemLayout.labelCol
      }
      wrapperCol={
        wrapperCol
          ? { span: wrapperCol }
          : formItemLayout && formItemLayout.wrapperCol
      }
    >
      {getFieldDecorator(fieldName, {
        ...{ initialValue },
        rules: [
          {
            required: message && !optional,
            message,
          },
        ],
      })(
        <TextArea
          disabled={disabled}
          autoSize={autoSize}
          maxLength={maxLength}
          allowClear={allowClear}
          onChange={handleChange}
        />
      )}
    </Form.Item>
  );
};

export default TextAreaItem;
